import memoize from 'lodash.memoize';
import { createSelector } from 'reselect';

/**
 * Access to form key
 * @param {Object} state - redux store
 */
export const formFromState = ({ form }) => form;

/**
 * Retrieve state of specific form
 * @param {String} name - Name of the form to retrieve
 * @returns {Function}
 */
export const getFormFromStateSelector = memoize((name) =>
  /**
   * @param {Object} state - redux store
   */
  createSelector(
    formFromState,
    form => form?.[name],
  )
);
